import { render, staticRenderFns } from "./Picker.vue?vue&type=template&id=f1519166"
import script from "./Picker.vue?vue&type=script&lang=ts"
export * from "./Picker.vue?vue&type=script&lang=ts"
import style0 from "./Picker.vue?vue&type=style&index=0&id=f1519166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports